import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  TableAdv,
  showToast,
  ToolTip,
  useFormHandler,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import PayDayDetails from "./UpcomingPaydays/PayDayDetails";
import { upcommingpayfrequency } from "../../../../assets/data/projectData";
import { upcommingpaydaytableData } from "../../../../assets/data/candidatesData";
import { useDispatch, useSelector } from "react-redux";
import {
  clearEmpPayConfigMain,
  clearPayroll,
  getAllEmpPayConfigsStart,
  getAllPayrollStart,
} from "../../../../redux/slices/payroll/payrollSlice";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import dayjs from "dayjs";
import { exactUTCDate } from "../../../../utils/dateFormator";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";

const UpcomingPaydays = () => {
  const dispatch = useDispatch();
  const [totalUpcomingPaydays, setTotalUpcomingPaydays] = useState(0);
  const [isPayrollGenerated, setIsPayrollGenerated] = useState(false);
  const { payroll: upcomingPaydaysData, loading } =
    useSelector((state) => state.payRoll) || {};
  // const { value } = useSelector((state) => state.totalCount);

  // const totalCount = value?.payrolls?.data;
  const [forceRender, setForceRender] = useState(false);

  const forceRerender = () => {
    setForceRender((prev) => !prev);
  };

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {}
  );

  useEffect(() => {
    dispatch(
      getAllPayrollStart({
        coll: "Payroll",
        useAggregate: true,
        limit: limit,
        page: page,
        filters: {
          upcoming: {
            type: "AG_GROUP",
            value: ["payCycle.from", "payCycle.to", "salaryProfileId"],
            // count:  true
          },
        },
        // ref: "SalaryProfile",
      })
    );
    // dispatch(
    //   totalCountStart({
    //     collection: "payrolls",
    //     coll: "Payroll",
    //     // filters: {
    //     //   upcoming: {
    //     //     type: "AG_GROUP",
    //     //     value:["payCycle.from", "payCycle.to", "salaryProfileId"],
    //     //   },
    //     // },
    //   })
    // );
    const fetchTotalCount = async () => {
      const response = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.PAYROLL.GET_ALL,
        params: {
          coll: "Payroll",
          useAggregate: true,
          // ref
          fil: JSON.stringify({
            upcoming: {
              type: "AG_GROUP",
              value: ["payCycle.from", "payCycle.to", "salaryProfileId"],
              count: true,
            },
          }),
        },
      });
      const totalCount = response?.data?.data || [];
      // console.log("totalCount", totalCount);
      setTotalUpcomingPaydays(totalCount?.[0]?.TotalCount || 0);
    };
    fetchTotalCount();
    return () => {
      dispatch(clearPayroll());
    };
  }, [dispatch, limit, page, forceRender]);
  const [selectedPayDay, setSelectedPayDay] = useState(null);

  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    selectPayFrequency: "",
    payProfile: "",
    payrollMonth: null,
  });

  const handlePayDayClick = (row) => {
    setSelectedPayDay(row);
  };

  const columns = [
    {
      key: "payDay",
      label: "Pay Day",
      render: (row) => {
        return (
          <span
            className="cursor-pointer text-info"
            onClick={() => handlePayDayClick(row)}
          >
            {exactUTCDate(row.payDay)}
          </span>
        );
      },
    },
    {
      key: "payPeriod",
      label: "Pay Period",
      width:"text-nowrap!",
      render: (row) => {
        // const [fromStr, toStr] = row.payPeriod?.split(" TO ") || [];
        // if (!fromStr || !toStr) return "-";
        const fromdate = row?.payCycle?.from
          ? dayjs(row?.payCycle?.from).utc().format("MM/DD/YYYY")
          : "";
        const todate = row?.payCycle?.to
          ? dayjs(row?.payCycle?.to).utc().format("MM/DD/YYYY")
          : "";
        // const fromdate = row?.payCycle?.from
        //   ? exactUTCDate(row?.payCycle?.from)
        //   : "";
        // const todate = row?.payCycle?.to
        //   ? exactUTCDate(row?.payCycle?.to)
        //   : "";
        const formatDate = fromdate && todate ? `${fromdate} to ${todate}` : "";
        return `${formatDate || "-"}`;
      },
    },
    {
      key: "linkedEmployees",
      label: "Linked Employees",
      render: (row) => {
        return (
          <span className="cursor-pointer text-info">
            {row?.docs?.length || "-"}
          </span>
        );
      },
    },
    {
      key: "payProfile",
      label: "Pay Profile",
      render: (row) => {
        return (
          <span className="cursor-pointer text-info">
            {row?.salaryProfileId?.name || "-"}
          </span>
        );
      },
    },
    { key: "payFrequency", label: "Pay Frequency" },
    { key: "unpaidEmpoyees", label: "Unpaid Empoyees" },
    { key: "totalPayrollAmount", label: "Total Payroll Amount" },
    { key: "totalPayout", label: "Total Payout" },
    { key: "pendingPayout", label: "Pending Payout" },
    {
      key: "lastUpdate",
      label: "Last Update",
      render: (row) => dateFormator(row.lastUpdate, "datetime"),
    },
  ];
  const tableData = upcomingPaydaysData?.data || [];
  const mappedRows = mapTableRows(tableData, columns);

  const handlePayrollGeneration = async () => {
    try {
      if (!formData.payrollMonth) {
        showToast("Please select a month to generate payrolls", "error", 5000);
        return;
      }
      let date = dayjs(formData.payrollMonth).date(15).add(1, "month").format("YYYY-MM-DD");
      // return;
      setIsPayrollGenerated(true);
      const result = await axiosRequest({
        method: "POST",
        url: `${ENDPOINTS.MISC.RUN_SERVER_TASKS}/payroll`,
        data: {
          task: "monthly",
          input: date,
        },
      });
      if (result.data?.data.success) {
        showToast("Payrolls generated successfully", "success", 5000);
      } else {
        console.error("Error in function handlePayrollGeneration",result?.data?.data)
        showToast("Unable to generate payrolls", "error", 5000);
      }
    } catch (error) {
      console.log("error:::::::::::::::::", error);
    } finally {
      forceRerender();
      setIsPayrollGenerated(false);
    }
  };

  return (
    <div>
      {selectedPayDay ? (
        <PayDayDetails
          row={selectedPayDay}
          onClose={() => setSelectedPayDay(null)}
          forceRerender={forceRerender}
          paycyclevalue={selectedPayDay.period}
          paydayvalue={dateFormator(selectedPayDay.payDay, "month-day-year")}
          totalempvalue={selectedPayDay.linkedEmployees}
        />
      ) : (
        <TableAdv
          tableId="payroll_upcomingpaydays"
          rows={mappedRows}
          columns={columns}
          serverPagination={true}
          // totalCount={totalCount}
          totalCount={totalUpcomingPaydays}
          page={page}
          limit={limit}
          onPageChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            add: [
              {
                component: (
            <div className="flex flex-wrap gap-2 mt-2 mb-2 items-center px-2">
              {/* <FormFieldSet
                type="text"
                noTitle
                size="sm" // this has no effect, bug?
                placeholder="Pay Profile"
                value={formData.payProfile || ""}
                onChange={(value) => handleChange("payProfile", value)}
                error={errors.payProfile}
              />
              <FormFieldSet
                type="select"
                size="sm"
                noTitle
                placeholder="Select Pay Frequency"
                value={formData.selectPayFrequency || ""}
                onChange={(value) => handleChange("selectPayFrequency", value)}
                error={errors.selectPayFrequency}
                options={upcommingpayfrequency}
              />
              <div>
                <Button size="sm" title={"Search"} onClick={""} />
              </div>*/}
              <div className="min-w-[200px]">
                <FormFieldSet
                  type="monthpicker"
                  size="sm"
                  noTitle
                  placeholder="Payroll Month"
                  value={formData.payrollMonth || ""}
                  onChange={(value) => handleChange("payrollMonth", value)}
                />
              </div>
              <div className="min-w-[200px]">
                <Button
                  size="sm"
                  variant="outlined"
                  title={"Generate Payrolls Manually"}
                  onClick={handlePayrollGeneration}
                  disabled={!formData.payrollMonth}
                />
              </div>
            </div>
                )}]
          }}
        />
      )}
      <Backdrop isOpen={loading || isPayrollGenerated}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default UpcomingPaydays;
